"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameInfoFlags = void 0;
var GameInfoFlags;
(function (GameInfoFlags) {
    GameInfoFlags[GameInfoFlags["None"] = 0] = "None";
    GameInfoFlags[GameInfoFlags["LiveStatus"] = 1] = "LiveStatus";
    GameInfoFlags[GameInfoFlags["Broadcasts"] = 2] = "Broadcasts";
    GameInfoFlags[GameInfoFlags["Conditions"] = 4] = "Conditions";
    GameInfoFlags[GameInfoFlags["WeatherInfo"] = 8] = "WeatherInfo";
    GameInfoFlags[GameInfoFlags["Referee"] = 16] = "Referee";
    GameInfoFlags[GameInfoFlags["Venue"] = 32] = "Venue";
    GameInfoFlags[GameInfoFlags["ExtraInfo"] = 64] = "ExtraInfo";
    GameInfoFlags[GameInfoFlags["StreamingChannels"] = 128] = "StreamingChannels";
    GameInfoFlags[GameInfoFlags["BetBuilder"] = 256] = "BetBuilder";
})(GameInfoFlags = exports.GameInfoFlags || (exports.GameInfoFlags = {}));
